export const PUBLICATION_OVERVIEW_BLOCK_FIELDS_CONSTS = {
  autocompleteMsg: 'Автоматически подставляется заголовок новости',
  characterLimitReachedMsg: 'Достигнут лимит по кол-ву символов',
  subtitleMaxLength: 90,
  subtitleMsg: 'Подзаголовок для главной',
  titleMaxLength: 70,
  titleMsg: 'Заголовок для главной'
}
